import { leadConstants } from "../constants";

const initialState = {
  loading: false,
  leads: [],
};

export function addLead(state = {}, action) {
  switch (action.type) {
    case leadConstants.ADD_LEAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case leadConstants.ADD_LEAD_SUCCESS:
      return {
        ...state,
        loading: false,
        lead: action.data,
      };
    case leadConstants.ADD_LEAD_FAILURE:
      return {
        err: action.error,
        loading: false,
      };
    default:
      return state;
  }
}

export function getLeads(state = { loading: false, sortOption: 1, filterOption: 0, leads: [] }, action) {
  switch (action.type) {
    case leadConstants.GET_LEADS_REQUEST:
      return {
        loading: true,
      };
    case leadConstants.GET_LEADS_SUCCESS:
      return {
        loading: false,
        leads: action.data.data,
        sortOption: action.data.sortOption,
        filterOption: action.data.filterOption,
        pagination: action.data.pagination,
      };
    case leadConstants.GET_LEADS_FAILURE:
      return {
        err: action.error,
        loading: false,
      };
    default:
      return state;
  }
}

export function uploadExcel(state = {}, action) {
  switch (action.type) {
    case leadConstants.UPLOAD_EXCEL_REQUEST:
      return {
        loading: true,
      };
    case leadConstants.UPLOAD_EXCEL_SUCCESS:
      return {
        loading: false,
        data: action.data,
      };
    case leadConstants.UPLOAD_EXCEL_FAILURE:
      return {
        err: action.error,
        loading: false,
      };
    default:
      return state;
  }
}

export function addNote(state = {}, action) {
  switch (action.type) {
    case leadConstants.ADD_NOTES_REQUEST:
      return {
        loading: true,
      };
    case leadConstants.ADD_NOTES_SUCCESS:
      return {
        loading: false,
        data: action.data,
      };
    case leadConstants.ADD_NOTES_FAILURE:
      return {
        err: action.error,
        loading: false,
      };
    case leadConstants.ADD_NOTES_CLEAR:
      return {};
    default:
      return state;
  }
}

export function changeLeadToSaleOpportunity(state = {}, action) {
  switch (action.type) {
    case leadConstants.CHANGE_TO_SALE_OPPORTUNITY_REQUEST:
      return {
        loading: true,
      };
    case leadConstants.CHANGE_TO_SALE_OPPORTUNITY_SUCCESS:
      return {
        loading: false,
        data: action.data,
      };
    case leadConstants.CHANGE_TO_SALE_OPPORTUNITY_FAILURE:
      return {
        err: action.error,
        loading: false,
      };
    default:
      return state;
  }
}


export function pinLead(state = {}, action) {
  switch (action.type) {
    case leadConstants.PIN_LEAD_REQUEST:
      return {
        loading: true,
      };
    case leadConstants.PIN_LEAD_SUCCESS:
      return {
        loading: false,
        data: action.data,
      };
    case leadConstants.PIN_LEAD_FAILURE:
      return {
        err: action.error,
        loading: false,
      };
    default:
      return state;
  }
}


export function editContactInformation(state = { loading: false }, action) {
  switch (action.type) {
    case leadConstants.EDIT_CONTACT_INFORMATION_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case leadConstants.EDIT_CONTACT_INFORMATION_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.data,
      };
    case leadConstants.EDIT_CONTACT_INFORMATION_FAILURE:
      return {
        err: action.error,
        loading: false,
      };
    default:
      return state;
  }
}


export function cancellationReasonLead(state = { loading: false, list: [] }, action) {
  switch (action.type) {
    case leadConstants.GET_CANCELLATION_REASON_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case leadConstants.GET_CANCELLATION_REASON_SUCCESS:
      return {
        ...state,
        loading: false,
        list: action.data,
      };
    case leadConstants.GET_CANCELLATION_REASON_FAILURE:
      return {
        err: action.error,
        loading: false,
      };
    default:
      return state;
  }
}

export function cancelLead(state = { loading: false }, action) {
  switch (action.type) {
    case leadConstants.CANCEL_LEAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case leadConstants.CANCEL_LEAD_SUCCESS:
      return {
        ...state,
        loading: false,
        list: action.data,
      };
    case leadConstants.CANCEL_LEAD_FAILURE:
      return {
        err: action.error,
        loading: false,
      };
    default:
      return state;
  }
}

export function acceptLead(state = { loading: false }, action) {
  switch (action.type) {
    case leadConstants.ACCEPT_LEAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case leadConstants.ACCEPT_LEAD_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case leadConstants.ACCEPT_LEAD_FAILURE:
      return {
        err: action.error,
        loading: false,
      };
    default:
      return state;
  }
}
